const ExhibitionEventsLogistics = () => {
  return (
    <div>
    
    <div className="flex flex-col justify-center  gap-1 max-w-[50rem] mx-auto pl-[2rem] pr-[2rem] pt-[1rem]">
      <h1 className="text-[20px] font-bold">Exhibition & Events Logistics</h1>
      <p>
        As the official logistics partner to countless major expos and events, TCS can bring your 
        event or exhibition plans to life. Whether it is an international sporting event, a music 
        concert or a product launch, from fleet & transportation, to international freight forwarding 
        and customs house brokerage, we handle all aspects of exhibition and events logistics.
      </p>
     

     
    </div>
  </div>  
  );
};
  
export default ExhibitionEventsLogistics;
  